import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors } from '../../../styles/Variables'

export const GiftCardWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .gift-card-hero-container {
    display: flex;
    flex-direction: column;
    max-width: 1600px;
    width: 100%;

    
    .hero-container-inner {
      width: 100%;
      height: 560px;
      display: flex;
      flex-direction: row;

      ${mq('max', '768px')} {
        flex-direction: column;
        height: initial;
      }
      
      .content {
        width: 50%;
        height: 100%;
        background-color: ${gsColors.cobalt};
        display: flex;
        justify-content: center;
        align-items: center;
  
        ${mq('max', '768px')} {
          width: 100%;
          height: 400px;
          min-height: 400px;
        }
        
        .inner {
          margin: 0 150px 0 88px;
  
          ${mq('max', '1290px')} {
            margin: 0px 40px;
          }
          
          ${mq('max', '768px')} {
            margin: 28px 16px;
          }
          
          h1 {
            color: ${gsColors.salmon};
  
            ${mq('max', '768px')} {
              margin-bottom: 8px !important;
              width: 60%;
            }
          }
  
          p {
            ${mq('max', '768px')} {
              line-height: 26.4px;
              width: 90%;
            }
          }
        }
      }
      
      .image-placeholder {
        height: 100%;
        background-color: #4D4D4D;
        width: 50%;
        position: relative;

        img {
          object-fit: cover;
          object-position: 50% 0%;
        }
  
        ${mq('max', '768px')} {
          width: 100%;
          height: 500px;
          min-height: 500px;
        }
      }
    }

    .gift-input-container {
      width: 100%;
      height: 110px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: rgba(232, 226, 225, 0.50);

      ${mq('max', '920px')} {
        flex-direction: column;
        height: auto;
        padding: 30px 16px;
      }

      ${mq('max', '768px')} {
        display: none;
        flex-direction: column;
        align-items: flex-start;
      }

      div {
        ${mq('max', '920px')} {
          align-items: center;
        }

        ${mq('max', '768px')} {
          align-items: flex-start;
        }
      }

      h3 {
        ${mq('max', '920px')} {
          font-size: 18px;
          margin: 0 0 20px 0 !important;
          text-align: center;
        }
      }

      button {
        ${mq('max', '920px')} {
          margin-top: 31px;
        }

        ${mq('max', '768px')} {
          margin-top: 31px;
          width: 100%;
        }
      }
    }

    .mobile-gift-input-container {
      width: 100%;
      min-height: 80px;
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: rgba(232, 226, 225, 0.50);

      ${mq('max', '768px')} {
        display: flex;
      }

      .mobile-gift-input-button {
        width: 100%;
        height: 100%;
        height: 80px;
        background-color: transparent;
        border: none;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        h3 {
          font-size: 18px !important;
        }
      }
      
      .mobile-input-display {
        padding: 0 16px 40px;
        width: 100%;

        div {
          ${mq('max', '920px')} {
            align-items: center;
          }
  
          ${mq('max', '768px')} {
            align-items: flex-start;
          }
        }
  
        h3 {
          ${mq('max', '920px')} {
            font-size: 18px;
            margin: 0 0 20px 0 !important;
            text-align: center;
          }
        }
  
        button {
          ${mq('max', '920px')} {
            margin-top: 31px;
          }
  
          ${mq('max', '768px')} {
            margin-top: 31px;
            width: 100%;
          }
        }
      }
      
    }
  }
  
  .gift-card-input {
    .gift-card-unauthenticated {
      button {
        margin: 0;
        min-width: auto;
        padding: 0 20px;
      }
    }

    ${mq('max', '768px')} {
      width: 100%;
    }

    div {
      display: flex;
      margin-right: 1rem;

      ${mq('max', '920px')} {
        flex-direction: column;
        margin: 0;
      }

      div {
        ${mq('max', '768px')} {
          width: 100%;
        }
      }
    }

    p {
      max-width: 280px;
      text-align: center;
    }

  }

  .gift-card-location-container {
    width: 100%;
    max-width: 1600px;
    padding-top: 67px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq('max', '768px')} {
      padding-top: initial;
      padding: 60px 16px 0;
    }

    h2 {
      max-width: 540px;

      ${mq('max', '768px')} {
        max-width: 80%;
      }
    }

    h4 {
      ${mq('max', '768px')} {
        margin-bottom: 18px !important;
      }
    }

    .location-divider {
      margin-top: 80px;
      
      ${mq('max', '768px')} {
        margin-top: 60px;
      }
    }
  }

  .gift-card-choose-product {
    width: 100%;
    max-width: 1600px;
    padding-top: 109px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq('max', '768px')} {
      padding: 55px 16px 0;
    }

    .gift-card-options {
      display: flex;
      flex-direction: row;
      gap: 12.4px;
      justify-content: center;
      margin-bottom: 80px;

      ${mq('max', '768px')} {
        width: 100%;
        flex-direction: column;
        margin-bottom: 60px;
      }

      button {
        box-sizing: border-box;
        background-color: #FFF;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 30px 40px;
        border: 1px solid #E8E2E1;
        cursor: pointer;

        ${mq('max', '768px')} {
          width: 100%;
          padding: 28px 16px;
          align-items: flex-start;
        }

        &.selected {
          border: 1.5px solid ${gsColors.sunsetOrange};
        }

        h2 {
          ${mq('max', '768px')} {
            font-size: 28px !important;
          }
        }
        
        p {
          ${mq('max', '768px')} {
            font-size: 18px !important;
          }  
        }
      }
    }
    
  }

  .divider {
    width: 65%;
    border-bottom: 2px solid ${gsColors.lightTangerine};

    ${mq('max', '768px')} {
      width: 100%;
    }
  }

  .choose-amount-container {
    padding-top: 67px; 
    width: 100%;
    max-width: 1600px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq('max', '768px')} {
      padding: 60px 16px 0;
    }

    p {
      width: 667px;
      text-align: center;

      ${mq('max', '768px')} {
        width: 100%;
      }
    }

    h2 {
      ${mq('max', '768px')} {
        margin-bottom: 9px !important;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 624px;

      .mobile-custom-button-container {
        width: 100%;
      }

      .custom-price-input-container {
        margin: 20px 0 -24px;

        ${mq('max', '768px')} {
          margin: 20px 0 0;
        }
      }

      .gift-option-button {
        box-sizing: border-box;
        background-color: transparent;
        border: 1px solid ${gsColors.lightTangerine};
        font-family: Euclid;
        font-size: 18px;
        font-weight: 400;
        display: flex;
        height: 54px;
        justify-content: center;
        align-items: center;
        width: max-content;
        flex: 1 0 0;
        cursor: pointer;

        &.selected {
          border: 1.5px solid ${gsColors.sunsetOrange};
        }

        &.custom-mobile {
          display: none;

          ${mq('max', '768px')} {
            display: flex;
            margin-top: 8px;
            width: 100%;
            height: 54px;
          }
        }
        
        &.custom-web {
          display: flex;

          ${mq('max', '768px')} {
            display: none;
          }
        }
      }

      .price-container {
        margin-top: 26px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 12px;

        ${mq('max', '768px')} {
          margin-top: 36px;
        }
      }
      
      .occasion-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 14px;

        ${mq('max', '768px')} {
          flex-wrap: wrap;
        }

        button {
          ${mq('max', '768px')} {
            box-sizing: border-box;
            min-width: 40% !important;
            flex-grow: 1;
          }
        }

      }

      .personal-message {
        width: 100%;
        color: #000;
        padding: 16px;
        font-family: Euclid;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        border: 1px solid ${gsColors.lightTangerine};
        height: 140px;
        margin-bottom: 80px;
        
        &:placeholder {
          color: ${gsColors.meredithGrey};
        }

        ${mq('max', '768px')} {
          margin-bottom: 60px;
        }
      }

      h3 {
        ${mq('max', '768px')} {
          font-size: 18px !important;
          margin: 36px 0 18px !important;
        }
      }
    }
  }

  .recipient-info-container {
    padding-top: 67px; 
    width: 100%;
    max-width: 1600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    &._hide:after{
      content: "";
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #FFF;
      opacity: 0.7;
      position: absolute;
    }


    ${mq('max', '768px')} {
      padding: 60px 16px 0;
    }

    h2 {
      ${mq('max', '768px')} {
        margin-bottom: 40px !important;
      }
    }

    h3 {
      ${mq('max', '768px')} {
        font-size: 18px !important;
        margin: 36px 0 18px !important;
      }
    }

    .recipient-form {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 410px;
      gap: 24px;

      ${mq('max', '768px')} {
        width: 100%;
        max-width: initial;
      }
    }
    
    .recipient-delivery {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 410px;

      ${mq('max', '768px')} {
        width: 100%;
        max-width: initial;
      }

      .delivery-buttons {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 12px;

        button {
          background-color: transparent;
          display: flex;
          height: 54px;
          justify-content: center;
          align-items: center;
          flex: 1 0 0;
          box-sizing: border-box;
          border: 1px solid ${gsColors.lightTangerine};
          font-family: Euclid;
          font-size: 18px;
          font-weight: 400;
          line-height: 100%;
          cursor: pointer;

          &.selected {
            border: 1.5px solid ${gsColors.sunsetOrange};
          } 
        }
      }

      // .calendar-button {
      //   color: #000;
      //   font-family: Euclid;
      //   font-size: 18px;
      //   font-style: normal;
      //   font-weight: 400;
      //   line-height: 120%;
      //   letter-spacing: 0.36px;

      //   background-color: transparent;
      //   border: none;
      //   border-bottom: 1px solid #000;
      //   display: flex;
      //   width: 100%;
      //   height: 54px;
      //   padding: 12px 0px;
      //   justify-content: space-between;
      //   align-items: center;
      //   flex-shrink: 0;
      //   cursor: pointer;
      // }

      // .calendar-extended {
      //   width: 100%;

      //   color: #000;
      //   font-family: Euclid;
      //   font-size: 14px;
      //   font-style: normal;
      //   font-weight: 400;
      //   line-height: 120%;
      //   letter-spacing: 0.36px;
        
      //   .react-calendar__navigation {
      //     span {
      //       font-family: Euclid;
      //     }
      //   }

      //   .calendar-tile {
      //     box-sizing: border-box;
      //     border: 0.5px solid ${gsColors.lightTangerine};
      //     color: #000;
      //     font-family: Euclid;
      //     font-size: 14px;
      //     font-style: normal;
      //     font-weight: 400;
      //     line-height: 120%;
      //     letter-spacing: 0.36px;
          
      //     &.react-calendar__tile--now {
      //       color: #000;
      //       background-color: #FFF;
      //     }

      //     &.react-calendar__tile--active {
      //       color: #FFF;
      //       background-color: ${gsColors.sunsetOrange};
      //     }

      //   }
      // }
    }
  }

  .choose-package-container {
    padding-top: 67px; 
    width: 100%;
    max-width: 1600px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq('max', '768px')} {
      padding: 60px 16px 0;
    }

    h4 {
      ${mq('max', '768px')} {
        margin: 0 0 18px !important;
      }
    }

    h2 {
      ${mq('max', '768px')} {
        margin: 0 0 8px !important;
      }
    }

    p {
      ${mq('max', '768px')} {
        width: 80% !important;
      }
    }

    .package-text {
      width: 667px;
      text-align: center;

      ${mq('max', '768px')} {
        width: 100%;
      }
    }

    .choose-package-divider {
      margin-top: 80px;

      ${mq('max', '768px')} {
        margin-top: 60px;
      }
    }
  }

  .gift-card-package-amount-container {
    padding: 5rem 0 0 6.5rem;
    width: 100%;

    ${mq('max', '1000px')} {
      width: 90%;
      margin: 0 auto;
    }

    div {

      ${mq('max', '1000px')} {
        width: 100%;

      }
    }

    ${mq('max', '1000px')} {
      display: flex;
      justify-content: center;
      padding: 5rem 0 0 0;
    }

    h4 {
      margin: 0 0 1rem;
    }

    p {
      max-width: 650px;
    }
  }

  .gift-card-options-display {
    max-width: 650px;
    width: 100%;
    background-color: ${gsColors.white};
    padding: 1.5rem;
    margin-top: 1rem;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);

    ${mq('max', '630px')} {
      max-width: 1000px;
      margin-top: 1rem;
    }

    p {
      margin-top: .5rem;
    }

    h4 {
      font-weight: 300;
    }

    h4:nth-of-type(2) {
      color: ${gsColors.sunsetOrange};
    }

    h4:nth-of-type(3) {
      margin-top: 2rem;
    }

    .gift-card-price-options {
      display: flex;
      flex-wrap: wrap;

      button {
        all: unset;
        height: 2.5rem;
        width: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${gsColors.white};
        border: 0.5px solid ${gsColors.paleSlate};
        color: ${gsColors.paleSlate};
        margin-right: 0.5rem;
        border-radius: 5px;
        transition: all 0.5s ease;

        ${mq('max', '600px')} {
          margin-top: .5rem;
        }

        &:hover {
          cursor: pointer;
          border: 1px solid ${gsColors.darkEggplant};
          color: ${gsColors.darkEggplant};
        }

        &:focus {
          border: 1px solid ${gsColors.darkEggplant};
          color: ${gsColors.darkEggplant};
        }

        &.selected {
          color: ${gsColors.white};
          background-color: ${gsColors.darkEggplant};
          border: 0.5px solid ${gsColors.darkEggplant};
          transition: all 0.5s ease;
        }
      }

      button:nth-of-type(5) {
        width: 5rem;
      }
    }

    .custom-amount {
      margin: 2rem 0;

      div {
        display: flex;
        transform: translate(-.5rem);

        label {
          transform: translateX(1rem);
        }

        input {
          border: none;
          border-bottom: 0.5px solid ${gsColors.paleSlate};
          padding-left: 1.5rem;
          font-size: 16px;
          width: 95%;
          transition: all 0.5s ease;

          &:focus {
            outline: none;
            border-bottom: 1px solid ${gsColors.black};
          }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }

    .hide-custom-amount {
      display: none;
    }

    .occasion {
      display: flex;
      margin-bottom: 2rem;
      flex-wrap: wrap;
      max-width: 100%;

      button {
        all: unset;
        height: 2.5rem;
        width: max-content;
        padding: 0 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${gsColors.white};
        border: 0.5px solid ${gsColors.paleSlate};
        color: ${gsColors.paleSlate};
        margin-right: 0.5rem;
        border-radius: 5px;
        transition: all 0.5s ease;

        ${mq('max', '600px')} {
          margin-top: .5rem;
        }

        &:hover {
          cursor: pointer;
          border: 1px solid ${gsColors.darkEggplant};
          color: ${gsColors.darkEggplant};
        }

        &:focus {
          border: 1px solid ${gsColors.darkEggplant};
          color: ${gsColors.darkEggplant};
        }

        &.selected {
          color: ${gsColors.white};
          background-color: ${gsColors.darkEggplant};
          border: 0.5px solid ${gsColors.darkEggplant};
          transition: all 0.5s ease;
        }
      }
    }

    .personal-message {
      resize: none;
      margin-bottom: .5rem;
      width: 95%;
      padding: 1rem;
      height: 100px;
      font-family: Brown;
      border: 0.5px solid ${gsColors.paleSlate};
      transition: all 0.5s ease;

      &:focus {
        outline: none;
        border: 1px solid ${gsColors.black};
      }
    }
  }

  .package-container {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    .error-text {
      width: auto !important;
    }

    .gift-card-package-card {
      padding: 30px 20px;
      border: 1px solid ${gsColors.lightTangerine};
      background-color: ${gsColors.white};
      max-width: 624px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;
      box-sizing: border-box;
      cursor: pointer;

      &.selected {
        border: 1.5px solid ${gsColors.sunsetOrange};
      }

      
      .package-card-top {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        h3 {
          ${mq('max', '768px')} {
            font-size: 20px !important;
          }
        }

        p {
          width: initial !important;
        }
      }
      
      .package-card-bottom {
        
        div {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          gap: 8px;
        }

        h3 {
          ${mq('max', '768px')} {
            font-size: 16px !important;
          }
        }
        
        p {
          width: initial !important;

          ${mq('max', '768px')} {
            font-size: 16px !important;
          }
        }
      }
    }
  }

  .gift-card-recipient-container {
    padding: 5rem 0 0 6.5rem;
    width: 100%;

    ${mq('max', '1000px')} {
      padding: 5rem 0 0;
      display: flex;
      justify-content: center;
    }

    .inner-container {


      ${mq('max', '1000px')} {
        width: 90%;
      }

      h4 {
        margin: 0 0 1rem;
      }
  
      .recipient-info-display {
        max-width: 650px;
        width: 100%;
        background-color: ${gsColors.white};
        padding: 1rem;
        margin-top: 1rem;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  
        h4 {
          font-weight: 300;
        }
  
        input {
          margin: 0 0 1.5rem;
          width: 95%;

          &.error {
            border-color: ${gsColors.sunsetOrange};
            margin-bottom: .2rem;
          }
        }
  
        .package-occasion-info {
          width: 100%;
          .occasion {
            margin-bottom: 2rem;
              display: flex;
              margin-bottom: 2rem;
              flex-wrap: wrap;
              max-width: 100%;

              button {
                all: unset;
                height: 2.5rem;
                width: max-content;
                padding: 0 1rem;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: ${gsColors.white};
                border: 0.5px solid ${gsColors.paleSlate};
                color: ${gsColors.paleSlate};
                margin: .5rem .5rem 0 0;
                border-radius: 5px;
                transition: all 0.5s ease;
      
                &:hover {
                  cursor: pointer;
                  border: 1px solid ${gsColors.darkEggplant};
                  color: ${gsColors.darkEggplant};
                }
      
                &:focus {
                  border: 1px solid ${gsColors.darkEggplant};
                  color: ${gsColors.darkEggplant};
                }
      
                &.selected {
                  color: ${gsColors.white};
                  background-color: ${gsColors.darkEggplant};
                  border: 0.5px solid ${gsColors.darkEggplant};
                  transition: all 0.5s ease;
                }
              }

          }
    
          .personal-message {
            resize: none;
            margin-bottom: .5rem;
            width: 95%;
            padding: 1rem;
            height: 100px;
            font-family: Brown;
            border: 0.5px solid ${gsColors.paleSlate};
            transition: all 0.5s ease;
    
            &:focus {
              outline: none;
              border: 1px solid ${gsColors.black};
            }
          }
        }
  
        .delivery-options {
          display: flex;
          margin: 0 0 1rem;
  
          button {
            all: unset;
            height: 2.5rem;
            width: max-content;
            padding: 0 1rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: ${gsColors.white};
            border: 0.5px solid ${gsColors.paleSlate};
            color: ${gsColors.paleSlate};
            margin-right: 0.5rem;
            border-radius: 5px;
            transition: all 0.5s ease;
  
            &:hover {
              cursor: pointer;
              border: 1px solid ${gsColors.darkEggplant};
              color: ${gsColors.darkEggplant};
            }
  
            &:focus {
              border: 1px solid ${gsColors.darkEggplant};
              color: ${gsColors.darkEggplant};
            }
  
            &.selected {
              color: ${gsColors.white};
              background-color: ${gsColors.darkEggplant};
              border: 0.5px solid ${gsColors.darkEggplant};
              transition: all 0.5s ease;
            }
        }

        div {
          .email-date-picker-text {
            margin: 0 0 1rem;
          }
        }
      }
    }
  }
`
